import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as fnbActions from './../../../../../../actions/fnbAction';
import ProductList from './ProductList';

const mapStateToProps = state => {
    return {
        fnbState: state.fnbReducer,
        properties: state.fnbReducer.properties,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProducts: (filters) => dispatch(fnbActions.getProducts(filters)),
        syncProducts: (payload) => dispatch(fnbActions.syncProducts(payload)),
        getProperties: () => dispatch(fnbActions.getProperties()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ProductList));
